import api from "./api";

export const transactionService = {
  // Get transaction history with filtering
  getTransactionHistory: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.type) params.append("type", filters.type);
    if (filters.direction) params.append("direction", filters.direction);
    if (filters.status) params.append("status", filters.status);
    if (filters.wallet_type) params.append("wallet_type", filters.wallet_type);
    if (filters.date_from) params.append("date_from", filters.date_from);
    if (filters.date_to) params.append("date_to", filters.date_to);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.offset) params.append("offset", filters.offset);

    const queryString = params.toString();
    const url = queryString ? `/transactions?${queryString}` : "/transactions";
    const response = await api.get(url);
    return response.data;
  },

  // Get specific transaction by reference
  getTransactionById: async (transactionRef) => {
    const response = await api.get(`/transactions/${transactionRef}`);
    return response.data;
  },

  // Helper methods for specific transaction types
  getPurchaseHistory: async (filters = {}) => {
    return transactionService.getTransactionHistory({
      ...filters,
      type: "purchase",
    });
  },

  getRefundHistory: async (filters = {}) => {
    return transactionService.getTransactionHistory({
      ...filters,
      type: "refund",
    });
  },

  getCommissionHistory: async (filters = {}) => {
    return transactionService.getTransactionHistory({
      ...filters,
      type: "commission",
    });
  },

  // Get transactions by direction
  getDebitTransactions: async (filters = {}) => {
    return transactionService.getTransactionHistory({
      ...filters,
      direction: "debit",
    });
  },

  getCreditTransactions: async (filters = {}) => {
    return transactionService.getTransactionHistory({
      ...filters,
      direction: "credit",
    });
  },

  // Get transactions by wallet type
  getAffordableDataTransactions: async (filters = {}) => {
    return transactionService.getTransactionHistory({
      ...filters,
      wallet_type: "affordable_data",
    });
  },

  getAirtimeDataTransactions: async (filters = {}) => {
    return transactionService.getTransactionHistory({
      ...filters,
      wallet_type: "airtime_data",
    });
  },
};
